/**
 * Buzz'd 2026 Theme — Main JS
 */

(function() {
  'use strict';

  /* --- Marquee: clone content for infinite scroll --- */
  document.querySelectorAll('.marquee__inner').forEach(function(el) {
    if (!el.dataset.cloned) {
      el.innerHTML += el.innerHTML;
      el.dataset.cloned = 'true';
    }
  });

  /* --- Mobile menu toggle (backup for inline onclick) --- */
  var toggle = document.querySelector('.site-header__menu-toggle');
  var nav = document.getElementById('site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      nav.classList.toggle('active');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
    });
  }

  /* --- Menu page: category tab switching --- */
  document.querySelectorAll('.menu-categories__tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = this.dataset.target;
      document.querySelectorAll('.menu-categories__tab').forEach(function(t) {
        t.classList.remove('active');
      });
      this.classList.add('active');
      document.querySelectorAll('.menu-section[data-category]').forEach(function(sec) {
        if (target === 'all' || sec.dataset.category === target) {
          sec.style.display = '';
        } else {
          sec.style.display = 'none';
        }
      });
    });
  });

  /* --- Sticky header shadow on scroll --- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(13,77,74,0.15)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
